var __jsx = React.createElement;
import React, { createContext, useContext } from "react";
var AccordionItemContext = /*#__PURE__*/createContext(undefined);
var AccordionItemProvider = function AccordionItemProvider(_ref) {
  var children = _ref.children,
    open = _ref.open,
    toggleOpen = _ref.toggleOpen;
  return /*#__PURE__*/React.createElement(AccordionItemContext.Provider, {
    value: {
      open: open,
      toggleOpen: toggleOpen
    }
  }, children);
};
var useAccordionItem = function useAccordionItem() {
  var context = useContext(AccordionItemContext);
  if (!context) {
    throw new Error("useAccordionItem must be used within an AccordionItemProvider");
  }
  return context;
};
export { AccordionItemProvider, useAccordionItem };